// Copyright (c) 2017 Deere & Company

import AuditDealerHierarchyFacetAccordionContainer from './dealer-hierarchy-facet-accordion';
import actionCreators from '../../action-creators';
import {connect} from 'react-redux';

const getStateToBindToContainerProps = state => ({
    dealerHierarchyFacet: state.tcsm.audits.dealerHierarchyFacet,
    facetFilterText: state.tcsm.audits.facetFilterText,
    filteredTerritories: state.tcsm.audits.filteredTerritories,
    territories: state.tcsm.audits.leadAccount
});

const mapBoundActionCreatorsToActionsProp = (stateProps, dispatchProps, parentProps) => {

    const {routeParams} = parentProps;

    const {
        readAudits,
        resetDealerHierarchyFacet,
        updateDealerHierarchyFacet,
        updateFacetFilterText,
        updateFilteredTerritories
    } = dispatchProps;

    return {
        ...stateProps,
        actions: {
            readAudits,
            resetDealerHierarchyFacet,
            updateDealerHierarchyFacet,
            updateFacetFilterText,
            updateFilteredTerritories
        },
        routeParams
    };

};

export default connect(getStateToBindToContainerProps, actionCreators, mapBoundActionCreatorsToActionsProp)(AuditDealerHierarchyFacetAccordionContainer);



// WEBPACK FOOTER //
// ./src/tcsm/audits/components/dealer-hierarchy-facet/index.js